import Swiper, { Pagination, Navigation, A11y } from 'swiper'

let defaultSwiperAttributes = {
  spaceBetween: 30,
  slidesPerView: 1,
  slidesPerGroup: 1,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  a11y: true,
}

document.querySelectorAll('.swiper-container').forEach((element, index) => {
  let swiperAttributes = element.hasAttribute('data-swiper') ? { ...defaultSwiperAttributes, ...(JSON.parse(element.getAttribute('data-swiper'))) } : defaultSwiperAttributes
  let swiper = new Swiper(element, swiperAttributes)
});
